import { PageHeading } from "@/components/common/PageHeading.tsx";
import { LoginForm } from "@/components/auth/Login.form.tsx";
import { Link, useNavigate } from "react-router-dom";
import { useStore } from "@/stores/useStore.ts";
import { useEffect } from "react";

const LoginPage = () => {
  const authState = useStore((s) => s.authState);
  const navigate = useNavigate();
  useEffect(() => {
    if (authState !== "unauthenticated") {
      navigate("/");
    }
  }, [authState]);

  return (
    <div className="flex flex-col gap-4 m-auto">
      <PageHeading>Login to Get Started</PageHeading>
      <LoginForm />
      <div className="text-sm">
        No account? Register{" "}
        <Link className="underline" to="/register">
          here
        </Link>
      </div>
      <div className="text-sm">
        Forgot password? Reset{" "}
        <Link className="underline" to="/reset">
          here
        </Link>
      </div>
    </div>
  );
};

export default LoginPage;
